import moment from 'moment'

export function getDateRangeFromRangeIndex (range, index) {
  let output = []

  if (range !== 'custom') {
    let firstDay = moment().add(index, range).startOf(range).utc().toString()
    let lastDay = moment().add(index, range).endOf(range).utc().toString()
    output = [firstDay, lastDay]
  }

  return output
}

export function getRangeIndexFromDateRange (dateRange, currentDate) {
  let firstDay = moment(dateRange[0])
  let lastDay = moment(dateRange[1])
  let numberOfDays = lastDay.diff(firstDay, 'day')
  let daysInMonth = firstDay.daysInMonth()
  let isDay = numberOfDays === 0
  let isWeek = numberOfDays === 6 && firstDay === firstDay.startOf('week')
  let isMonth = numberOfDays === daysInMonth - 1 && firstDay === firstDay.startOf('month')
  let range = isDay ? 'day' : isWeek ? 'week' : isMonth ? 'month' : 'custom'
  let index = range !== 'custom' ? Math.ceil(firstDay.diff(currentDate, range, true)) : undefined

  return { range: range, index: index }
}
